import axios from 'axios'
import Vue from 'vue'
// import router, { currentLanguage, sportID } from '@/router'
import { currentLanguage } from '@/router'
import { checkEmptyObject } from '@/utils'

function getENV () {
  const host = window.location.host
  if (host.indexOf('127.0.0.1') !== -1 || host.indexOf('localhost') !== -1) {
    return '.dev'
  } else if (host.indexOf('dev') !== -1) {
    return '.dev'
  } else if (host.indexOf('test') !== -1) {
    return '.test'
  } else {
    return ''
  }
}

/*
function getENV2 () {
  let flag = getENV().replace('-', '')
  return flag + flag.length > 0 ? '.' : ''
}
*/

function appendLanguageParams (config) {
  let lanParam = { 'lan': currentLanguage }
  config.params = config.params ? { ...config.params, ...lanParam } : lanParam
  return config
}

function responseHandle (response) {
  if (response.data['status']) {
    if (response.data.status === 1 && response.data['data']) {
      return {
        ...response.data.data,
        netState: checkEmptyObject(response.data.data) ? 3 : 0
      }
    } else {
      return Promise.reject(new Error(response.data.msg))
    }
  } else {
    return { ...response, netState: 2 }
  }
}

let dataBaseClient = {
  httpMethod: {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete'
  },

  instance: axios.create({
    baseURL: `https://data-mobi-js${getENV()}.7msport.com/`
  }),

  /**
   *
   * @param url
   * @param options
   * @returns {*|Promise}
   */
  doGet (url, options = null) {
    return this.doRequest(url, this.httpMethod.GET, null, options)
  },

  /**
   * Http Post
   * @param url
   * @param body
   * @param options
   * @returns {*|Promise}
   */
  doPost (url, body = null, options = null) {
    return this.doRequest(url, this.httpMethod.POST, body, options)
  },

  /**
   * Http Put
   * @param url
   * @param body
   * @param options
   * @returns {*|Promise}
   */
  doPut (url, body = null, options = null) {
    return this.doRequest(url, this.httpMethod.PUT, body, options)
  },

  /**
   * Http Delete
   * @param url
   * @param options
   * @returns {*|Promise}
   */
  doDelete (url, options = null) {
    return this.doRequest(url, this.httpMethod.DELETE, null, options)
  },

  /**
   * Http Request
   * @param url
   * @param method
   * @param body
   * @param options
   * @returns {Promise}
   */
  doRequest (url, method, body, options) {
    let request = null
    switch (method) {
      case this.httpMethod.GET: {
        if (options !== null) {
          request = this.instance.get(url, { params: options })
        } else {
          request = this.instance.get(url)
        }
        break
      }
      case this.httpMethod.POST: {
        request = this.instance.post(url, body, options)
        break
      }
      case this.httpMethod.PUT: {
        request = this.instance.put(url, body, options)
        break
      }
      case this.httpMethod.DELETE: {
        request = this.instance.delete(url, options)
        break
      }
    }
    return this._requestPromise(request)
  },

  /**
   * Request Promise
   * @param request {Promise} Axios Http Promise
   * @returns {Promise}
   * @private
   */
  _requestPromise (request) {
    return new Promise(function (resolve, reject) {
      request.then(response => {
        resolve(response)
      }, error => {
        console.log('err' + error) // for debug
        Vue.toasted.show(error.message)
        return Promise.reject(error)
      })
    })
  }
}

dataBaseClient.instance.interceptors.request.use(appendLanguageParams, (error) => {
  return Promise.reject(error)
})

dataBaseClient.instance.interceptors.response.use(responseHandle, (error) => {
  return Promise.reject(error)
})

export { dataBaseClient }
